import { Component, input } from '@angular/core';
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { AbbButtonComponent } from '@components/abb-button/abb-button.component';
import { TPipe } from '@pipes/t.pipe';
import { Icon } from '@components/abb-icon/icons';
import { SELECTION } from '@utils/table';

export type MenuItem<T> = {
  icon?: Icon;
  disabledCondition?: (item: any) => boolean;
  label: string;
  action: (items: T[]) => Promise<void> | void;
  selectionAllowed?: SELECTION;
};

@Component({
  selector: 'abb-actions-menu',
  standalone: true,
  imports: [CdkMenuTrigger, CdkMenu, CdkMenuItem, AbbButtonComponent, TPipe],
  template: `
    <span class="flex flex-row">
      <abb-button
        variant="none"
        id="actionMenu"
        [cdkMenuTriggerFor]="menu"
        class="inline-flex text-abb-primary"
        [icon]="'mat/more_horiz'"
      />
      <ng-template #menu>
        <div
          class="flex flex-col bg-abb-background text-xs border border-abb-font rounded-lg min-w-24"
          cdkMenu
        >
          @for(item of menuItems(); track item; let first = $first; let last =
          $last){
          <abb-button
            cdkMenuItem
            [id]="item.label"
            [disabled]="item.disabledCondition?.(rowData()) ?? false"
            [className]="
              'gap-2 !justify-start w-full h-10 px-2 text-abb-font hover:bg-abb-primary-light/20 ' +
              (first
                ? 'border-b border-b-abb-font hover:rounded-t-lg'
                : last
                ? 'hover:rounded-b-lg'
                : 'border-b border-b-abb-font')
            "
            variant="none"
            (click)="item.action([rowData()])"
            [icon]="item?.icon"
            iconSize="small"
          >
            {{ item.label | t }}
          </abb-button>
          }
        </div>
      </ng-template>
    </span>
  `,
  styles: ``,
})
export class AbbActionsMenuComponent<T> {
  menuItems = input.required<Array<MenuItem<T>>>();
  rowData = input.required<T>();
}
